<div c-work-unit-view class="child sub-view">
    <div class="content solo">
        <section class="child">
            <div c-toggle="viewVisible" c-toggle-options="{type: 'fade'}">
                <h1>{{"workUnit.header"|translate}}</h1>
                <div c-select-list toggle="0" items="workUnits" selected-item="selectedWorkUnit" validation="validation"></div>
            </div>
        </section>
    </div>
</div>

